
const { registerBlockType } = wp.blocks;
const { InspectorControls } = wp.editor;
import { PanelBody } from '@wordpress/components';
import React, { useState, useEffect } from 'react';
import Parser from "html-react-parser";
import jQuery from "jquery";

//custom components
import Productid from "./controls/productid";
import SourceProduct from "./controls/sourceproduct";


const { Component } = wp.element;

registerBlockType('migblocks/share-product', {
    title: 'Gumroad Share Product',
    icon: 'store',
    category: 'apijoin-gumroad',
    attributes: {
        productId: {
            type: "string",
            default: ""
        },
        sourceProduct: {
            type: "string",
            default: "twitter"
        },
    },



    edit: class extends Component {
        constructor(props) {
            super(props);

            this.myRef = React.createRef();

        }
        componentDidMount(props){
            /*
            let iframe = this.myRef.current;
            let id = iframe.getAttribute("id");

            iframe.height = "1000px"
            
            setTimeout(function(){
                let height = jQuery("#"+id).contents().height();
                console.log(height);
                
            }, 6000);
           */
        }

        componentDiUpdate(props){
            
        }


        render() {
           
      

            const { attributes: { productId, sourceProduct}, setAttributes } = this.props;
            let source = sourceProduct;
           
            let finalProductId = "";
            if(productId){
                finalProductId = `https://gum.co/${productId}`;
            }
            let content = "";

            if(source == "facebook"){
                content += `<button class="button apijoin-gumsharebutton apijoin-share-facebook" data-sharer="facebook" data-url="${finalProductId}"><span class="apijoin-gumicon dashicons dashicons-facebook-alt"></span>Share</button>`;
            }
            else {
                content += `<button class="button apijoin-gumsharebutton apijoin-share-twitter" data-sharer="twitter" data-title="Buy Divi Section Enhancer on @Gumroad" data-url="${finalProductId}"><span class="apijoin-gumicon dashicons dashicons-twitter"></span>Tweet</button>`;
            }

            let origin = encodeURIComponent(window.origin);
           
            

            if(productId) {  
                return (
                    <React.Fragment>
                        <InspectorControls>
                            <PanelBody title={"Product Options"} initialOpen={true} >
                                
                                <Productid {...this.props}/>
                                <SourceProduct {...this.props}/>
                                
                                
                            </PanelBody>
                        </InspectorControls>

                        {Parser(content)}
                    </React.Fragment> 
                

                );
            }
            
            return (
                <React.Fragment>
                        <InspectorControls>
                            <PanelBody title={"Product Options"} initialOpen={true} >
                                
                                <Productid {...this.props}/>
                                <SourceProduct {...this.props}/>
                                
                                
                            </PanelBody>
                        </InspectorControls>

                        <h2 className="apijoin-nogumroad-id">
                            Insert a Product ID
                        </h2>
                        
                        
                    </React.Fragment> 
            );
              
           

        }
    },

    save: class extends Component {

        constructor(props) {
            super(props);

        }



        render() {
            const { attributes: { productId, sourceProduct}} = this.props;
            let source = sourceProduct;
           
            let finalProductId = "";
            if(productId){
                finalProductId = `https://gum.co/${productId}`;
            }
            let content = "";

            if(source == "facebook"){
                content += `<button class="button apijoin-gumsharebutton apijoin-share-facebook" data-sharer="facebook" data-url="${finalProductId}"><span class="apijoin-gumicon dashicons dashicons-facebook-alt"></span>Share</button>`;
            }
            else {
                content += `<button class="button apijoin-gumsharebutton apijoin-share-twitter" data-sharer="twitter" data-title="Buy Divi Section Enhancer on @Gumroad" data-url="${finalProductId}"><span class="apijoin-gumicon dashicons dashicons-twitter"></span>Tweet</button>`;
            }

            let origin = encodeURIComponent(window.origin);
           

            return (

                

                <React.Fragment>
                    {Parser(content)}
                </React.Fragment> 
          

            );
        }





    }


});
